import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../../../../../../../../../queries/rewards';
import {
	usePagination,
	useStore,
} from '../../../../../../../../../../../utils/hooks';
import { RewardsTable } from '../../../../../../../../../../presentational';
import { useRewardsFilters } from '../FilterProvider';

/**
 * @description Smart component that fetches rewards based on url filters
 */
export const Table = ({ campaignId, campaign }) => {
	const { getRewards } = useStore();
	const { state, update } = useRewardsFilters();
	const [getPagination] = usePagination({
		limit: state.limit || 10,
	});

	/**
	 * update the rewards list on relevant query state changes or when data is stale
	 */
	const { isLoading, isRefetching, isError, data, error } = useQuery(
		queryKeys.list({
			campaignId,
			...state,
		}),
		() =>
			getRewards({
				campaignId,
				...state,
			}),
		{ enabled: !!campaignId, refetchOnWindowFocus: false }
	);

	const sortConfig = {
		sortServer: true,
		defaultSortField: 'updatedAt',
	};

	/**
	 * control pagination
	 */
	const paginationConfig = {
		paginationServer: true,
		paginationDefaultPage: state.page || 1,
		paginationTotalRows: data?.rewards?.count,
		paginationPerPage: state.limit || 10,
		onChangePage: (next) => {
			const { skip, page } = getPagination({ page: next });
			update({ skip, page });
		},
		onChangeRowsPerPage: (currentRowsPerPage, page) => {
			const { skip, limit } = getPagination({
				page,
				limit: currentRowsPerPage,
			});
			update({ skip, limit });
		},
	};

	return isError ? (
		error?.message
	) : (
		<RewardsTable
			collection={data?.rewards?.rows}
			campaign={campaign}
			progressPending={isLoading || isRefetching}
			{...paginationConfig}
			{...sortConfig}
		/>
	);
};
